"use client";

import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

export default function AdminGuard({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      router.push("/signin");
      return;
    }

    // Verify token and role with backend
    fetch("/api/auth/me", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Invalid session");
        return res.json();
      })
      .then((data) => {
        if (data.success && data.user.role === "admin") {
          setAuthorized(true);
          setLoading(false);
        } else {
          // Access denied: Not an admin
          localStorage.removeItem("token");
          router.push("/signin");
        }
      })
      .catch((err) => {
        console.error("Admin verification error:", err);
        localStorage.removeItem("token");
        router.push("/signin");
      });
  }, [router]);

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="flex flex-col items-center">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
          <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">Verifying admin access...</p>
        </div>
      </div>
    );
  }

  return authorized ? <>{children}</> : null;
}

